import { FormModel } from "@com.mgmtp.a12.formengine/formengine-core/lib/models";

export function replaceTitleInFormModel(formModel: FormModel, newTitle: string): FormModel {
	const header = { ...formModel.header, labels: [{ locale: "de", text: newTitle }] };
	return { ...formModel, header: header };
}
export function hasAnnotation(element: FormModel.Annotated, annotation: string, value?: string) {
	return (element.annotations ?? []).some(it => it.name === annotation && (value ? it.value === value : true));
}
